import Navbar from "../components/Navbar";
import { useState } from "react";
import { db, auth } from "../firebase/firebaseConfig";
import { collection, addDoc } from "firebase/firestore";

function Feedback() {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setStatus("sending");
    try {
      const user = auth.currentUser;
      await addDoc(collection(db, "feedbacks"), {
        uid: user?.uid || "anonymous",
        email: user?.email || "anonymous",
        name: user?.displayName || "Anonymous",
        message: message,
        timestamp: new Date().toISOString()
      });
      setStatus("success");
      setMessage("");
      setTimeout(() => setStatus("idle"), 3000);
    } catch (err) {
      console.error("Feedback error:", err);
      setStatus("error");
    }
  };

  return (
    <div style={{ minHeight: "100vh", paddingBottom: "3rem" }}>
      <Navbar />
      <div className="app-container" style={{ maxWidth: '600px', margin: '0 auto', marginTop: '2rem' }}>
        <div className="glass-morphism animate-fade-in" style={styles.card}>
           <h2 className="gradient-text" style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>FEEDBACK</h2>
           <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem', fontSize: '0.9rem' }}>
             Found a bug? Have a suggestion for the leaderboard? Let us know what you think of the IPL Arena!
           </p>

           <form onSubmit={handleSubmit} style={styles.form}>
             <textarea 
               value={message}
               onChange={(e) => setMessage(e.target.value)}
               placeholder="Write your thoughts here..."
               style={styles.textarea}
               rows={6}
               required
             />

             <button 
               type="submit" 
               disabled={status === "sending" || !message.trim()}
               style={{...styles.submitBtn, opacity: (!message.trim() || status === "sending") ? 0.5 : 1}}
             >
               {status === "sending" ? "DELIVERING..." : status === "success" ? "FEEDBACK SENT! 🎉" : "SUBMIT RESPONSE"}
             </button>

             {status === "error" && <p style={{color: '#ef4444', fontSize: '0.8rem', marginTop: '1rem'}}>Failed to send. Please try again.</p>}
           </form>
        </div>
      </div>
    </div>
  );
}

const styles = {
  card: { padding: '3rem', borderRadius: '32px', textAlign: 'center' },
  form: { display: 'flex', flexDirection: 'column', gap: '1.5rem' },
  textarea: { 
    width: '100%', 
    background: 'rgba(255,255,255,0.03)', 
    border: '1px solid var(--glass-border)', 
    borderRadius: '16px', 
    padding: '1.2rem', 
    color: 'var(--text-primary)', 
    fontSize: '1rem', 
    resize: 'none',
    outline: 'none',
    boxShadow: 'inset 0 4px 10px rgba(0,0,0,0.2)'
  },
  submitBtn: { 
    padding: '1.2rem', 
    background: 'var(--primary)', 
    color: '#000', 
    borderRadius: '16px', 
    fontWeight: '900', 
    fontSize: '1rem', 
    letterSpacing: '0.05em',
    cursor: 'pointer',
    border: 'none',
    transition: '0.2s',
    boxShadow: '0 4px 15px rgba(0, 118, 255, 0.2)'
  }
};

export default Feedback;
